/**
 * The "Incomplete" pill for a session that ended before its deck did. Shared
 * by the just-finished results screen and the history detail view so the two
 * name an early end the same way.
 */
export function IncompleteBadge({ className = '' }: { className?: string }) {
  return (
    <span
      className={`rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-amber-700 dark:bg-amber-900/30 dark:text-amber-300 ${className}`}
    >
      Incomplete
    </span>
  );
}
